import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { UserDTO } from 'ticket-sdk';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhoneNumberAlertService {
  private alertShownCount = 0;
  private isDataLoaded$ = new BehaviorSubject<boolean>(false);
  private showAlert = true;


  private readonly STORAGE_KEY: string = "PhoneNumberAlertServiceData";

  constructor(
    private storage: Storage,
    private alertController: AlertController,
    private router: Router
  ) { 
    this.loadPersistedData();
  }

  async displayAlertIfAppropriate(user: UserDTO) {
    this.isDataLoaded$.subscribe(async isDataLoaded => {
      
      if (isDataLoaded) {
        if (!this.showAlert || this.alertShownCount >= 5 || user.phone) {
          return;
        }
    
        const alert = await this.alertController.create({
          header: 'Koppla mobilnummer',
          message: 'Vill du koppla ditt mobilnummer för att få påminnelser via SMS?',
          inputs: [
            {
              name: 'doNotShowAgainCheckbox',
              type: 'checkbox',
              label: 'Visa inte igen',
              handler: (input) => {
                this.showAlert = !input.checked;
              },
              checked: false,
            },
          ],
          buttons: [
            {
              text: 'Nej',
              role: 'cancel',
              handler: () => {
                this.alertShownCount++;
                this.savePersistedData();
              }
            },
            {
              text: 'Ja',
              handler: () => {
                this.alertShownCount++;
                this.savePersistedData();
                this.router.navigateByUrl('/my-account?register-phone=true');
              }
            }
          ]
        });
    
        await alert.present();
      }
    });
  }

  private async loadPersistedData() {
    this.storage.get(this.STORAGE_KEY).then(data => {
      if (data) {
        this.alertShownCount = data.alertShownCount;
        this.showAlert = data.showAlert;
      }

      this.isDataLoaded$.next(true);
    });
  }

  private savePersistedData() {
    this.storage.set(this.STORAGE_KEY, {
      alertShownCount: this.alertShownCount,
      showAlert: this.showAlert
    });
  }
}
